import { motion } from "framer-motion";

const TIERS = [
    {
        lookup_key: "digital_bundle",
        name: "Digital & Audiobook",
        price: "$18",
        desc: "The story in your hands and in your ears, wherever you wander. Delivered on release day.",
    },
    {
        lookup_key: "hardcover_standard",
        name: "Standard Hardcover",
        price: "$28",
        desc: "First-edition hardcover, clothbound in deep Eden green with gold serif type.",
    },
    {
        lookup_key: "collectors_gold",
        name: "Collector's Gold Foil",
        price: "$45",
        desc: "Gold-foil stamped cover, signed bookplate, numbered first printing. Only 500 will ever exist.",
        sacred: true,
    },
];

export default function CheckoutSection() {
    return (
        <section id="preorder" data-testid="preorder-section" className="relative mx-auto max-w-6xl px-6 py-32">
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 1 }}
                className="text-center"
            >
                <p className="font-cinzel text-xs tracking-[0.4em] text-[#b89860] uppercase">
                    The First Edition
                </p>
                <h2 className="font-cinzel mt-6 text-3xl leading-snug text-[#f3e5ab] sm:text-5xl">
                    Reserve Your Place in the Garden
                </h2>
                <p className="font-cormorant mx-auto mt-5 max-w-xl text-lg italic text-[#a3b899]">
                    Three editions are being prepared for the unveiling.
                    Every pre-order will carry a guaranteed first-edition signed bookplate.
                </p>
            </motion.div>

            <div className="mt-20 grid gap-8 md:grid-cols-3">
                {TIERS.map((tier, i) => (
                    <motion.div
                        key={tier.lookup_key}
                        data-testid={`tier-${tier.lookup_key}`}
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.9, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
                        whileHover={{ y: -8 }}
                        className={`relative flex flex-col rounded-sm border p-8 backdrop-blur-md transition-[border-color,box-shadow] duration-300 ${
                            tier.sacred
                                ? "border-[rgba(212,175,55,0.55)] bg-[rgba(21,46,32,0.75)] shadow-[0_0_50px_rgba(255,200,100,0.1)]"
                                : "border-[rgba(212,175,55,0.22)] bg-[rgba(15,35,24,0.55)] hover:border-[rgba(212,175,55,0.45)]"
                        }`}
                    >
                        {tier.sacred && (
                            <span className="font-cinzel absolute -top-3 left-1/2 -translate-x-1/2 rounded-sm border border-[rgba(212,175,55,0.6)] bg-[#0f2318] px-4 py-1 text-[0.6rem] tracking-[0.3em] text-[#d4af37] uppercase">
                                Most Sacred
                            </span>
                        )}
                        <h3 className="font-cinzel text-lg tracking-wide text-[#f3e5ab]">{tier.name}</h3>
                        <p className="font-cinzel mt-4 text-4xl text-[#d4af37]">{tier.price}</p>
                        <p className="font-cormorant mt-4 flex-1 text-base leading-relaxed text-[#a3b899]">
                            {tier.desc}
                        </p>
                        <button
                            data-testid={`preorder-button-${tier.lookup_key}`}
                            disabled
                            className="btn-eden mt-8 w-full cursor-not-allowed rounded-sm bg-transparent px-6 py-4 text-xs text-[#8a7a60] opacity-80"
                        >
                            Coming Soon
                        </button>
                    </motion.div>
                ))}
            </div>

            <p className="font-cormorant mt-10 text-center text-base italic text-[#8a7a60]">
                Pre-orders open at the unveiling — approximately four months from now.
                Join the remembering below, and you will be the first through the gate.
            </p>
        </section>
    );
}
